<div class="loading-overlay" *ngIf="loading">
    <div class="loader-container">
        <div class="loader">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>

<div class="custom-margin">
    <section class="section-card">
        <div class="breadcrumb flat">
            <!-- <a routerLink="/vendor/dashboard">Vendor</a> -->
            <h3  class="active">Live Negotiation </h3>
        </div>

        <div class="form_basic mb-0">
            <div class="form_set">
                <!-- RFP Details Card -->
                <div class="custom-card radius-10">
                    <div class="card-body">
                        <div class="bothBoxCard row">
                            <!-- Left Section - RFP Details -->
                            <!-- RFP Details Card -->
                            <div class="col-md-4">
                                <div class="card time">
                                    <div class="card-body p-0">
                                        <h5 class="card-title mb-3" style="font-weight: 600; color: #fff;">RFP Details
                                        </h5>
                                        <div class="d-flex align-items-center justify-content-between">
                                            <p class="textPara">
                                                RFP Code.
                                                <span class="textSpan">{{rowData?.rfpCode || 'N/A'}}</span>
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-between">
                                            <p class="textPara">
                                                Neg. No.
                                                <span class="textSpan">{{rowData?.negotiationCode || 'N/A'}}</span>
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-between">
                                            <p class="textPara">
                                                Company Name
                                                <span class="textSpan">{{rowData?.companyBranchName || 'N/A'}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Middle Section - Countdown Timer -->
                            <div class="col-md-5">
                                <div class="card">
                                    <div class="card-body time">
                                        <h5 class="card-title" style="color: #fff; font-size: 14px;">
                                            Negotiation Closes on {{rowData.negotiationEndDate | date:'fullDate'}} -
                                            {{rowData.negotiationEndTime}} {{endTimeFormat}}
                                        </h5>
                                        <div class="row">
                                            <div class="count-down-timer">
                                                <div class="wrapper">
                                                    <div class="description">
                                                        <p>Days</p>
                                                        <p>Hours</p>
                                                        <p>Minutes</p>
                                                        <p>Seconds</p>
                                                    </div>
                                                    <div class="times">
                                                        <p #days></p>
                                                        <p #hours></p>
                                                        <p #minutes></p>
                                                        <p #seconds></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Right Section - Final Quote -->
                            <div class="col-md-3">
                                <div class="card">
                                    <div class="card-body time sx-sexx" style="text-align: center;">
                                        <h5 class="card-title" style="color: #fff;">Final Quote</h5>
                                        <h2 style="color: #0099dc; font-weight: 700; margin-top: 10px;">
                                            {{rowData?.currency_code | currencySymbol}}
                                            {{liveDetails.negotiationTotalAmount || 0}}
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Your Quote Section -->
                <div class="mt-3">
                    <h5 class="card-title mb-2 w-600" style="color: #144979; font-weight: 600;">Your Quote</h5>
                    <div class="table-responsive">
                        <table class="table table-bordered tableBusiness">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Product Name</th>
                                    <th>Quantity</th>
                                    <th>({{rowData?.currency_code | currencySymbol}}) Price Per Item</th>
                                    <th>CGST (%)</th>
                                    <th>SGST (%)</th>
                                    <th>IGST (%)</th>
                                    <th>({{rowData?.currency_code | currencySymbol}}) Additional Charges</th>
                                    <th>({{rowData?.currency_code | currencySymbol}}) Total</th>
                                    <th>Remarks</th>
                                    <th>({{rowData?.currency_code | currencySymbol}}) Admin Offer Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of liveDetails.vendorNegotiation; let i = index">
                                    <td>{{i+1}}</td>
                                    <td>
                                        <input type="text" class="form-control" name="itemName{{i}}"
                                            [(ngModel)]="item.itemName" disabled>
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" name="quantity{{i}}"
                                            [(ngModel)]="item.quantity" disabled>
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" name="itemPrice{{i}}"
                                            [(ngModel)]="item.itemPrice" (ngModelChange)="calculateItemSum(item)">
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" name="CGST{{i}}"
                                            [(ngModel)]="item.CGST" (ngModelChange)="onCGSTChange(item)"
                                            [disabled]="item.IGST > 0">
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" name="SGST{{i}}"
                                            [(ngModel)]="item.SGST" (ngModelChange)="onSGSTChange(item)"
                                            [disabled]="item.IGST > 0">
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" name="IGST{{i}}"
                                            [(ngModel)]="item.IGST" (ngModelChange)="onIGSTChange(item)"
                                            [disabled]="item.CGST > 0 || item.SGST > 0">
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" name="Additional_charges{{i}}"
                                            [(ngModel)]="item.Additional_charges"
                                            (ngModelChange)="calculateItemSum(item)">
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" name="priceIncludingCharges{{i}}"
                                            [(ngModel)]="item.priceIncludingCharges" disabled>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" name="negotiationDescription{{i}}"
                                            [(ngModel)]="item.negotiationDescription">
                                    </td>
                                    <td>{{item.itemOfferPrice || 0}}</td>
                                </tr>
                                <tr>
                                    <th colspan="10" class="text-right"
                                        style="background-color: #051a32; color: #b5b5c3; border: solid 1px #132f4c; text-align: right;">
                                        Final Quote
                                    </th>
                                    <td>
                                        <input type="number" class="form-control text-right"
                                            name="negotiationTotalAmount"
                                            [(ngModel)]="liveDetails.negotiationTotalAmount" disabled>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="d-flex justify-content-end mt-3">
                        <button class="submitButton" (click)="submit()" [disabled]="isSubmitDisabled">
                            <i class="fa-solid fa-floppy-disk"></i>&nbsp;<span>Submit</span>
                        </button>
                    </div>
                </div>

                <!-- Quote History Section -->
                <div class="mt-4">
                    <h5 class="card-title mb-2 w-600" style="color: #144979; font-weight: 600;">Your Quote History</h5>
                    <div class="table-responsive">
                        <table class="table table-bordered tableBusiness">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Frequency</th>
                                    <th>Time</th>
                                    <th>Final Quote</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of yourQuote; let i = index">
                                    <td>{{i+1}}</td>
                                    <td (click)="itemDetails(item)"
                                        style="color: #0099dc; text-decoration: underline; cursor: pointer;">
                                        {{item.negotiationFrequency}}
                                    </td>
                                    <td>{{ item.createdAt | date: 'medium' }}</td>
                                    <td>{{rowData?.currency_code | currencySymbol}} {{item.negotiationTotalAmount || 0}}
                                    </td>
                                </tr>
                                <tr *ngIf="yourQuote.length === 0">
                                    <td colspan="4" class="text-center">No history available</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Back Button -->
                <!-- <div class="mt-4 backNextButton">
                    <button class="backButton" (click)="back()">
                        <i class="fa-solid fa-arrow-left"></i>&nbsp;<span>Back</span>
                    </button>
                </div> -->
            </div>
        </div>
    </section>
</div>